import { render, staticRenderFns } from "./QualityDetail.vue?vue&type=template&id=7be4631e&scoped=true"
import script from "./QualityDetail.vue?vue&type=script&lang=js"
export * from "./QualityDetail.vue?vue&type=script&lang=js"
import style0 from "./QualityDetail.vue?vue&type=style&index=0&id=7be4631e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4631e",
  null
  
)

export default component.exports